<form #formRef="ngForm" class="sidebar-active">
	<bb-page-header [backOnMobile]="['/library/channels']" [icon]="'th'"
		[title]="channel ? channel.name : 'CHANNEL' | translate">
		<ul class="tabs" *ngIf="channel">
			<li>
				<a [routerLink]="['/library/channel', activeId, 'general']" routerLinkActive=""
					[class.active]="activeTab === 'general'">
					<!-- hack to fix routerLinkActive after create new -->
					<i class="fa fa-tags"></i> {{ 'GENERAL' | translate }}
				</a>
			</li>
			<li>
				<a [routerLink]="['/library/channel', activeId, 'elements']" routerLinkActive="active">
					<i class="fa fas fa-block-quote"></i> {{ 'ELEMENTS' | translate }}
				</a>
			</li>
			<li>
				<a [routerLink]="['/library/channel', activeId, 'detailpage']" routerLinkActive="active">
					<i class="fa fas fa-sitemap"></i> {{ 'DETAIL_PAGE' | translate }}
				</a>
			</li>
			<li>
				<a [routerLink]="['/library/channel', activeId, 'embed']" routerLinkActive="active">
					<i class="fa fa-code"></i> {{ 'EMBED' | translate }}
				</a>
			</li>
		</ul>

		<bb-status *ngIf="channel" [(ngModel)]="channel.status" name="status"></bb-status>
	</bb-page-header>

	<div class="body-column tab-container">
		<channel-details-general *ngIf="channel" [form]="form" [channel]="channel" [playerBlocks]="playerBlocks"
			[hidden]="activeTab !== 'general'" [backgroundColorPreset]="backgroundColorPreset" (onLogoChanged)="onLogoChanged($event)"></channel-details-general>
		<channel-details-detailpage *ngIf="channel" [form]="form" [channel]="channel"
			[hidden]="activeTab !== 'detailpage'" [backgroundColorPreset]="backgroundColorPreset">
		</channel-details-detailpage>
		<channel-details-elements *ngIf="channel" [form]="form" [channel]="channel" [hidden]="activeTab !== 'elements'"
			[playerBlocks]="playerBlocks" (onBlockAdded)="addBlock($event)" (onBlockDeleted)="deleteBlock($event)"
			(onBlockCopied)="copyBlock($event)" (onLogoChanged)="onLogoChanged($event)">
		</channel-details-elements>
		<channel-details-embed *ngIf="channel" [form]="form" [channel]="channel" [hidden]="activeTab !== 'embed'"
			[isActive]="activeTab === 'embed'">
		</channel-details-embed>
	</div>

	<div class="body-column preview-container">
		<ng-container *ngIf="channel">
			<div class="preview-device">
				<bb-form-element theme="light-v2" [hideLabel]="true">
					<bb-radio-list [ngModelOptions]="{standalone: true}" [valueOnlyModel]="true" mode="image"
						name="preview_device" [(ngModel)]="previewWidth" maxColumns="3" imageStyle="tab"
						[options]="previewOptions" [flexGrow]="false" (ngModelChange)="setPreviewWidth()">
					</bb-radio-list>
				</bb-form-element>
			</div>
			<div class="preview-wrapper" [style.width]="previewWidth">
				<div>
					<bb-channel #channelPreview [channelConfig]="channel"></bb-channel>
					<div *ngIf="channel.blocks?.length === 0" class="preview-placeholder"
						[style.background-color]="entity.backgroundColor ? '#' + entity.backgroundColor : '#ffffff'">
						<div class="preview-placeholder-illustration">
							<div class="bar bar1"></div>
							<div class="block">
								<i class="fa-regular fa-video"></i>
							</div>
							<div class="bar bar2"></div>
							<div class="bar bar3"></div>
							<div class="bar bar4"></div>
						</div>
					</div>
				</div>

				<div *ngIf="channel.blocks?.length === 0" class="preview-placeholder-text">
					<p>{{"NO_ELEMENTS_YET" | translate}}</p>
					<a [routerLink]="['/library/channel', activeId, 'elements']" [queryParams]="{new: true}">
						{{"ADD_ELEMENT" | translate}}
					</a>
				</div>
			</div>
		</ng-container>
	</div>
</form>

<bb-actions-bar (onSave)="save($event)" (onCancel)="cancel()" (onDelete)="delete($event)" [form]="form"
	[entity]="channel">
</bb-actions-bar>
